import { useState } from "react";

import Icon from "@components/ui/icon";
import type { StaticEntityType } from "@config";
import { useViewContext } from "@editor-providers";
import { TextLibrary } from "@library-elements/text";
import {
  StyledEditorContent,
  StyledEditorHeader,
  StyledEditorMain,
  StyledEditorWrapper,
} from "../styles/Collapsible.styled";
import type {
  CollapsibleTextProps,
  EditorDataProps,
  EditorSlotsProps,
} from "../types";

export const CollapsibleLibrary = ({
  entity,
  editorSlots,
  editorData,
}: {
  entity: StaticEntityType;
  editorSlots?: EditorSlotsProps;
  editorData?: EditorDataProps;
}) => {
  const { view } = useViewContext();
  const { settings, id } = entity as StaticEntityType<CollapsibleTextProps>;
  const isPdf = view === "pdf";
  const isEditor = view === "editor";
  const [isExpanded, setIsExpanded] = useState(false);
  const _isExpanded = isPdf ? true : isExpanded;
  const width = editorData?.width || settings.width;

  let titleIcon: string | undefined =
    settings[_isExpanded ? "titleIconClose" : "titleIconOpen"];
  if (!titleIcon) {
    titleIcon = _isExpanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line";
  }
  return (
    <StyledEditorWrapper
      onClick={editorData?.handleEntityClick}
      $horizontalAlignment={settings.horizontalAlignment}
      ref={editorData?.wrapperRef}
    >
      {editorSlots?.resizeSlot}
      <StyledEditorMain $width={width} ref={editorData?.elementRef}>
        <StyledEditorHeader
          {...EDITOR_ATTRIBUTES({ isEditor })}
          $textStyle={settings.titleTextStyle}
          $fontSize={settings.fontSize}
          $color={settings.titleColor}
          $horizontalAlignment={settings.titleHorizontalAlignment}
          $isBold={settings.titleBold}
          $isItalic={settings.titleItalic}
          $isUnderline={settings.titleUnderline}
          className="collapsible-text-aTdNqqZXed"
          onClick={(e) => {
            const target = e.target as HTMLElement;
            if ((!target.closest("span") && editorData?.active) || !isEditor)
              setIsExpanded((prev) => !prev);
          }}
        >
          {editorSlots?.editableTitleSlot || (
            <span
              className="tw-flex tw-items-center [&_p]:!tw-m-0"
              dangerouslySetInnerHTML={{ __html: settings.title ?? "&nbsp;" }}
            ></span>
          )}
          <Icon
            icon={titleIcon}
            className="collapsible-text__title-icon"
            style={{
              fontSize: "inherit",
              color: settings.titleIconColor || "inherit",
            }}
          />
        </StyledEditorHeader>
        <StyledEditorContent $isExpanded={_isExpanded}>
          <div className="sd-content-Mt1ZqRNHnnw6stkyr2HF">
            {editorData?.active && editorSlots?.editableContentSlot ? (
              editorSlots?.editableContentSlot
            ) : (
              <TextLibrary
                entity={{
                  settings: {
                    ...settings,
                    content: settings.content,
                  },
                  id,
                  children: [],
                  type: "element",
                }}
                editorData={{
                  width: 100,
                  content: settings.content || "",
                }}
              />
            )}
          </div>
        </StyledEditorContent>
      </StyledEditorMain>
    </StyledEditorWrapper>
  );
};

const EDITOR_ATTRIBUTES = ({ isEditor }: { isEditor: boolean }) => {
  const payload: Record<string, string> = {
    "data-dnd-trigger": "true",
  };
  return isEditor ? payload : {};
};
